export default {
  getShowProductStatusModal(state) {
    return state.showProductStatusModal;
  },
  getSingleProductDeleteRowId(state) {
    return state.singleProductDeleteRowId;
  },
  getSingleProductImageUploadRowId(state) {
    return state.singleProductImageUploadRowId;
  },
  getProductListActiveTab(state) {
    return state.productListActiveTab;
  },
  getIsProductLoading(state) {
    return state.isLoading;
  },
  getProductError(state) {
    return state.error;
  },
  getIsProductUpdate(state) {
    return state.isPriceAreaUpdate;
  },
  getIsPriceAreaStatus(state) {
    return state.isPriceAreaStatus;
  },
  getIsPriceAreaErrorMessage(state) {
    return state.isPriceAreaErrorMessage;
  },
  getActivePriceAreaInput(state) {
    return state.activePopoverId;
  },
  getSubTabsByKey(state) {
    return state.subTabsByKey;
  },
};